import { CompanyListPage } from "@/features/company/pages/CompanyList";
import { CompanyFilterCacheProvider } from "@/features/company/provider/CompanyListFilterCacheProvider";

const CompanyList = () => {
  return (
    <CompanyFilterCacheProvider>
      <CompanyListPage />
    </CompanyFilterCacheProvider>
  );
};

export default CompanyList;
